/* eslint-disable react-hooks/exhaustive-deps */
import { Button, CircularProgress, Grid, TextField, Typography } from '@material-ui/core';
import { gameBookTemplateActions } from '@orientaction/api-actions';
import ContainerAdmin from '@orientaction/commons/ContainerAdmin';
import MarginContainer from '@orientaction/commons/MarginContainer';
import { Layout } from '@orientaction/components';
import TestMainImage from '@orientaction/components/Admin/Test/Create/TestMainInfo/LeftImage/TestMainImage';
import { gameBookValues, gameVariables } from '@orientaction/reducers';
import { getFromLS } from '@orientaction/utils';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import Select from 'react-select';

import style from '../style';

const placeholder = () => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <span
        style={{
          fontSize: 26,
          margin: 8,
          border: '1px solid #E4E4F2',
          borderRadius: '50%',
          width: 36,
          height: 36,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        +
      </span>
      <span style={{ fontSize: 16 }}>Importer une image</span>
      <span style={{ color: 'black', marginTop: 10 }}>Résolution idéale : 260 x 364 px</span>
    </div>
  );
};

const EditGame = (props: any) => {
  const classes = style();
  const valuesBooksTemplate = useSelector(gameBookValues);
  const [file, setFile] = useState(null);
  const [url, setUrl] = useState(valuesBooksTemplate?.couvTemp || '');
  const [title, setTitle] = useState('');
  const token = getFromLS('userToken') || '';
  const [loading, setLoading] = useState<boolean>(false);
  const history = useHistory();
  const { id }: any = useParams();
  const [game, setGame] = useState<any>([]);
  const dispatch = useDispatch();
  const valuesVariables = useSelector(gameVariables);

  /* useEffect(() => {
    const fetchGameDetails = async () => {
      setLoading(true);
      try {
        const response = await apiServiceNative.get(`/api/details-game/${id}`);
        if (response && response.pages && response.pages.length > 0) {
          setGame(response);
          setTitle(response.title);
          setUrl(response.couverture);
          console.log({ response });
          // setUrl()
        } else {
          console.error('Invalid response structure:', response);
        }
      } catch (error) {
        console.error('Error fetching game details:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchGameDetails();
  }, [id]); */

  const handleFileUrlChange = (urlC: string) => {
    setUrl(urlC);
    dispatch(gameBookTemplateActions.updateField('couvTemp', urlC));
  };

  const handleFileChange = (fileC: any) => {
    setFile(fileC);
  };

  const handleDeleteFile = () => {
    setFile(null);
    setUrl('');
    dispatch(gameBookTemplateActions.updateField('couvTemp', ''));
  };

  const postGame = async () => {
    setLoading(true);
    const formData = new FormData();
    const pagesData = JSON.parse(sessionStorage.getItem('gamePages') || '[]');
    sessionStorage.setItem('indexNew', '0');
    dispatch(gameBookTemplateActions.updateField('pages', pagesData));
    formData.append('title', title);
    if (file) {
      formData.append('file.img', file as any);
      dispatch(gameBookTemplateActions.updateField('file.img', file));
    }

    history.push(`/admin/game/edit-page?novaya=0
    `);
    /* try {
      const response = await apiServiceNative.put(`/api/update-game-cover/${id}`, formData, true);
      console.log('Réponse du téléchargement :', response);
      if (response) {
        setLoading(false);
        setFile(null);
        setUrl('');
        setTitle('');

      }
    } catch (error) {
      console.error('Erreur lors de édition du jeu :', error);
      setLoading(false);
    } */
  };

  const optionsValue: any = [
    {
      value: 'classic',
      label: 'Classique',
    },
    {
      value: 'game',
      label: 'De test',
    },
  ];

  const handleFieldChange = (field: string, value: any) => {
    dispatch(gameBookTemplateActions.updateField(field, value));
  };

  useEffect(() => {
    console.log('data')
    sessionStorage.removeItem('goBack');
  }, []);

  const [selectTypeGame, setSelectTypeGame] = useState<any>(optionsValue[0]);

  useEffect(() => {
    if (valuesBooksTemplate?.typeGame === 'game') {
      setSelectTypeGame(optionsValue[1]);
    }
  }, [valuesBooksTemplate]);

  return (
    <Layout isaddBackground={true} showOverFlow={true}>
      {loading && (
        <CircularProgress
          color="inherit"
          size={40}
          style={{
            position: 'absolute',
            left: '50%',
            top: '50%',
            zIndex: 3,
          }}
        />
      )}
      <ContainerAdmin>
        <MarginContainer mormal={true}>
          <Grid
            container={true}
            spacing={2}
            direction="row"
            justifyContent="center"
            alignItems="center"
          >
            <Grid item={true} sm={12}>
              <Typography variant="h2" style={{ textTransform: 'none', textAlign: 'center' }}>
                Édition d’un jeu
              </Typography>
            </Grid>
          </Grid>
          <span className={classes.separator} />
          <Grid
            container={true}
            spacing={2}
            direction="row"
            justifyContent="center"
            alignItems="center"
          >
            <Grid item={true} sm={5} style={{ display: 'flex', justifyContent: 'center' }}>
              <div>
                <div className={classes.blockSelectType}>
                  <h3 className={classes.label}>Type de jeu</h3>
                  <div className={classes.blockBtnSelect}>
                    <Select
                      className={classes.select}
                      options={optionsValue}
                      value={selectTypeGame}
                      onChange={selected => {
                        setSelectTypeGame(selected);
                        handleFieldChange('typeGame', selected?.value);
                      }}
                    />
                    {selectTypeGame.value === 'game' && (
                      <Button variant="contained" color="primary" className={classes.btnPrimary} onClick={() => history.push('/admin/game/create-variables/edit')}>
                        Éditer les variables
                      </Button>
                    )}
                  </div>
                </div>
                <div className={classes.card}>
                  <h3 className={classes.label}>Titre du jeu</h3>
                  <TextField
                    id="create-test-title"
                    variant="outlined"
                    className={classes.formInput}
                    name="test-name"
                    value={valuesBooksTemplate?.titlGame || title}
                    onChange={(e) => {
                      handleFieldChange('titlGame', e.target.value);
                      handleFieldChange('title', e.target.value);
                    }}
                    placeholder="Indiquer ici le titre du jeu"
                  />

                  <h3 className={classes.label} style={{ marginTop: '25px' }}>
                    Image de la couverture
                  </h3>
                  <div style={{ position: 'relative' }}>
                    {!!url && (
                      <span className={classes.closeBtn} onClick={handleDeleteFile}>
                        x
                      </span>
                    )}
                    <TestMainImage
                      fileUrl={url}
                      handleFileUrlChange={handleFileUrlChange}
                      handleFileChange={handleFileChange}
                      placeholder={placeholder}
                      pathPrefix="tests"
                      sectionTop={true}
                      useForGame={true}
                    />
                  </div>
                </div>
                <Button
                  variant="contained"
                  color="primary"
                  disabled={
                    !valuesBooksTemplate?.couvTemp || !valuesBooksTemplate.titlGame || loading
                  }
                  className={classes.btnPrimary}
                  style={{ width: '100%', margin: '20px 0px' }}
                  onClick={postGame}
                >
                  Éditer le jeu
                </Button>
              </div>
            </Grid>
          </Grid>
        </MarginContainer>
      </ContainerAdmin>
    </Layout>
  );
};

export default EditGame;
